// The ONE public support address. Every mailto and every place the address is
// printed reads it from here. It must stay on the site's own domain: Google Ads
// review treats contact details on an unrelated domain as an unclear business.
// support@ since 2026-10-16 (owner made it as the friendly public mailbox).
// VITE_SUPPORT_EMAIL in Render overrides it at build time without a code change.
export const SUPPORT_EMAIL: string =
  (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined)?.trim() || 'support@faceshot-chopshop.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

// WhatsApp (Studio Blueprint 05-F, optional): VITE_SUPPORT_WHATSAPP in Render,
// the number in international form (e.g. +52 55 1234 5678). Empty means no
// WhatsApp button anywhere.
const WHATSAPP_DIGITS = ((import.meta.env.VITE_SUPPORT_WHATSAPP as string | undefined) || '').replace(/\D/g, '');
export const SUPPORT_WHATSAPP_URL: string | null = WHATSAPP_DIGITS.length >= 8 ? `https://wa.me/${WHATSAPP_DIGITS}` : null;
